import { memo, useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { deleteConfirmation } from '../../../utils/helpers';

const ItemGroupWithDeleteIcon = ({
  item,
  isSelectedGroup,
  removeClickAction,
  unSelectMedicineGroup,
  itemClickAction,
  selectedMedicines,
  onToggleMedicine,
  showMedicineName,
}) => {
  const [hoverClass, setHoverClass] = useState('complain-remove-btn');
  const [showMenu, setShowMenu] = useState(false);
  const containerRef = useRef(null);

  useClickAway(containerRef, () => setShowMenu(false));

  const medicines = item?.medicines || [];

  const getDisplayName = (medicine) => {
    const key = showMedicineName === 'any' ? 'brandName' : (showMedicineName || 'brandName');
    return medicine[key] || medicine.brandName || medicine.genericName || medicine.name || '';
  };

  return (
    <div
      ref={containerRef}
      className={`chief-complain-item mp-20 ${isSelectedGroup ? 'is-selected' : ''}`}
      onMouseOver={() => setHoverClass('complain-remove-btn-hover')}
      onMouseOut={() => setHoverClass('complain-remove-btn')}
    >
      <span
        onClick={() => isSelectedGroup ? unSelectMedicineGroup(item) : itemClickAction(item)}
        className="cursor-pointer"
      >
        {item.name}
      </span>
      {medicines.length > 0 && (
        <i
          className="fa fa-angle-down arrow-angle cursor-pointer"
          aria-hidden="true"
          onClick={() => setShowMenu((v) => !v)}
        />
      )}
      {showMenu && (
        <div className="cc-group-menu">
          {medicines.map((medicine, idx) => {
            const isItemSelected = selectedMedicines?.some((m) => m.id === medicine.id);
            return (
              <div
                key={idx}
                className={`cc-dropdown-item${isItemSelected ? ' selected-opt' : ''}`}
                onClick={() => onToggleMedicine(medicine)}
              >
                <input
                  type="checkbox"
                  checked={!!isItemSelected}
                  onChange={() => {}}
                  style={{ marginRight: '8px', cursor: 'pointer' }}
                />
                <span style={{ paddingTop: '2px' }}>{getDisplayName(medicine)}</span>
              </div>
            );
          })}
        </div>
      )}
      <span
        className={hoverClass}
        onClick={() => deleteConfirmation(removeClickAction, item.id)}
      >
        <i className="fa fa-minus-circle" aria-hidden="true" style={{ fontSize: '14px' }} />
      </span>
    </div>
  );
};

export default memo(ItemGroupWithDeleteIcon);
